import styled from '@emotion/styled'

export const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;

  > * {
    margin-bottom: 1.3rem;
  }
`
